import Pic from "assets/png/miss.png";

const Mission = () => {
  return (
    <section
      className="bg-gray-200 text-gray-900 py-20 px-6 md:px-12"
      id="mission"
    >
      <div className="max-w-7xl mx-auto text-center">
        <div className="flex justify-center">
          <img
            src={Pic}
            alt="Our Mission"
            className="rounded-lg w-16 object-contain"
          />
        </div>

        <h2 className="mt-6 text-3xl md:text-5xl font-bold">Our Mission</h2>

        <p className="mt-6 text-2xl lg:text-4xl text-black max-w-5xl mx-auto">
          Our mission at{" "}
          <span className="font-semibold text-blue-100">
            Noble Secure Technologies
          </span>{" "}
          is to harness the power of technology to create safer, more secure
          environments for our clients. We achieve this by designing,
          installing, and maintaining innovative security solutions that meet
          the unique needs of each client.
        </p>
      </div>
    </section>
  );
};

export default Mission;
